import React from "react";
import { FC } from "react";
import { ComponentProps } from "react";
import { Field } from "react-final-form";
import { useQuery } from "react-query";
import usePrivateClassQueries from "../hooks/usePrivateClassQueries";
import { QUERY_KEYS } from "../../../constants";
import Autocomplete from "../../../components/Autocomplete";
import FieldsGroupLabel from "../../language-course/modals/components/common/FieldsGroupLabel";

const PrivateClassSubjectField: FC<ComponentProps<any>> = React.memo(
  ({ hasError, ...props }) => {
    const { getPrivateClassSubjectList } = usePrivateClassQueries();
    const { privateClassSubjects } = QUERY_KEYS;

    const { isLoading, isFetching, data } = useQuery<any>(
      [privateClassSubjects],
      () => getPrivateClassSubjectList(),
    );

    const subjects = data?.data;

    return (
      <>
        <FieldsGroupLabel
          isRequired
          label="Subject"
          hasError={hasError}
          className="fields-group-label-first"
        />
        <Field
          loading={(isFetching || isLoading).toString()}
          options={subjects}
          groupBy={(option) => option.category}
          getOptionLabel={(option) => option.name}
          disabled={isLoading || isFetching}
          component={Autocomplete}
          {...props}
        />
      </>
    );
  },
);

export default PrivateClassSubjectField;
